import { Row, Col, Select, Pagination } from "antd";
import React, { useState } from "react";

interface Props {
  totalItems: number;
  isMobileOrTablet: boolean;
  onPageChange?: (page: number, pageSize: number) => void;
}

const ResponsivePagination: React.FC<Props> = ({
  totalItems,
  isMobileOrTablet,
  onPageChange,
}) => {
  const [pageSize, setPageSize] = useState(5);
  const [current, setCurrent] = useState(1);

  const handlePageChange = (page: number) => {
    setCurrent(page);
    onPageChange?.(page, pageSize);
  };

  const handlePageSizeChange = (value: number) => {
    setPageSize(value);
    setCurrent(1);
    onPageChange?.(1, value);
  };

  return (
    <Row
      gutter={[12, 12]}
      justify={isMobileOrTablet ? "center" : "space-between"}
      align="middle"
      style={{
        marginTop: 16,
        textAlign: isMobileOrTablet ? "center" : "unset",
      }}
    >
      <Col xs={24} sm={24} md={12} xl={12}>
        Results per Page{" "}
        <Select
          value={pageSize}
          style={{ width: 80 }}
          onChange={handlePageSizeChange}
          options={[
            { value: 5, label: "5" },
            { value: 10, label: "10" },
            { value: 20, label: "20" },
          ]}
        />{" "}
        of {totalItems} items
      </Col>

      <Col xs={24} sm={24} md={12} xl={12}>
        <Pagination
          style={{
            display: "inline-flex",
            float: isMobileOrTablet ? undefined : "inline-end",
          }}
          current={current}
          pageSize={pageSize}
          total={totalItems}
          showSizeChanger={false}
          onChange={handlePageChange}
        />
      </Col>
    </Row>
  );
};

export default ResponsivePagination;
